import React from 'react'
import { useForm } from 'react-hook-form'
import Form from '../../components/Form'
import FormItem from '../../components/Form/FormItem'
import Button from '../../components/General/Button'
import InputText from '../../components/Inputs/InputText'

const DigitalInvoiceForm: React.FC<IDigitalInvoiceForm> = ({
  tenantInfo,
  onCancel,
  onSubmit,
  isLoading = false,
}) => {
  const form = useForm({
    defaultValues: {
      digitalInvoiceUsername: tenantInfo?.digitalInvoiceUsername || '',
      digitalInvoicePassword: tenantInfo?.digitalInvoicePassword || '',
      digitalInvoiceSerie: tenantInfo?.digitalInvoiceSerie || '',
    },
  })

  const onSubmitForm = (values: any) => {
    onSubmit(values)
  }

  return (
    <Form
      form={form}
      onSubmit={onSubmitForm}
      classes={`grid grid-cols-12 gap-4`}
    >
      <h2 className="text-primary-900 font-bold dark:text-white mb-5 col-span-12">
        Facturación Digital
      </h2>

      <div className="col-span-12 mb-3">
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Aquí coloca las credenciales entregadas por CG Imprenta Digital para
          conectar tu cuenta de Zerux al servicio de facturación digital
        </p>
      </div>

      <FormItem
        name="digitalInvoiceUsername"
        classes="col-span-12"
        rules={{ required: 'El nombre de usuario es requerido' }}
      >
        <InputText small label="Nombre de Usuario" />
      </FormItem>

      <FormItem
        name="digitalInvoicePassword"
        classes="col-span-12"
        rules={{ required: 'El API Token es requerido' }}
      >
        <InputText password small label="API Token" />
      </FormItem>

      <FormItem
        name="digitalInvoiceSerie"
        classes="col-span-12"
        rules={{
          required: 'La serie es requerida',
          maxLength: { value: 3, message: 'La serie no puede tener más de 3 caracteres' }
        }}
      >
        <InputText small label="Serie de Facturación" maxLength={3} />
      </FormItem>

      <div className="col-span-12 flex mt-4">
        <Button
          type="outline"
          classes="w-1/2 mr-4"
          onClick={() => onCancel()}
          htmlType="button"
        >
          Cancelar
        </Button>

        <Button
          disabled={isLoading}
          loading={isLoading}
          type="primary"
          classes="w-1/2 mr-4"
          htmlType="submit"
        >
          Guardar cambios
        </Button>
      </div>
    </Form>
  )
}

interface IDigitalInvoiceForm {
  tenantInfo: any
  onCancel: () => void
  onSubmit: (values: any) => void
  isLoading: boolean
}

export default DigitalInvoiceForm
